// extracted by mini-css-extract-plugin
export default {"card-item":"CardItem_card-item__IC4W4","image":"CardItem_image__O8Rtt","title":"CardItem_title__iXj7O","cost":"CardItem_cost__cX9tc","button":"CardItem_button__3bBiC"};